import { render, staticRenderFns } from "./shop-result.vue?vue&type=template&id=25f7d93a&"
import script from "./shop-result.vue?vue&type=script&lang=js&"
export * from "./shop-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports